import { render, staticRenderFns } from "./vipLevl.vue?vue&type=template&id=ab55c3f2&"
import script from "./vipLevl.vue?vue&type=script&lang=js&"
export * from "./vipLevl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports